import React from 'react'
import { Navbar, Service } from './components';
import { About, Footer, Header, WorkWithUS, Product, Clients } from './containers';
import './App.css';

const App = () => {
  return (
    <div className='App'>
      <div className='gradient__bg'>
        <Navbar />
        <Header />
      </div>
      <Service />
      <Product />
      <WorkWithUS />
      <Clients />
      <About />
      <Footer />
    </div>
  )
}

export default App